"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
exports.default = (0, styles_1.styled)(ToggleButtonGroup_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        justifyContent: 'space-between',
        width: '100%',
        '& .MuiToggleButtonGroup-grouped': {
            padding: theme.spacing(0, 1.5),
            '&.Mui-disabled': {
                border: 0,
            },
            '&:not(:first-of-type), &:hover:not(:first-of-type)': {
                borderRadius: 5,
                borderColor: 'inherit',
                margin: 0,
            },
            '&:first-of-type': {
                borderRadius: 5,
            },
        },
    });
});
